/**
 * Semantic styles shared by the card confirmation variants (`card-saved`,
 * `payment-done` and `card-updated`). Mirrors the SPEI confirmation idiom so
 * the terminal outcomes of wizard step 5 stay visually consistent. The
 * label/value summary rows live in {@link ConfirmationSummaryRows}.
 *
 * Names describe the role of each element so the markup reads as a layout
 * outline rather than a wall of Tailwind utilities.
 */
export const cardConfirmationStyles = {
  root: 'my-auto flex w-full flex-col items-center gap-6 p-6 font-sans',
  card: 'flex w-full max-w-[500px] flex-col gap-4 p-6 shadow-xs',
  amountRow: 'flex flex-wrap items-center gap-1',
  amount: 'text-xl font-bold leading-8 text-foreground',
  noteBox: 'flex w-full max-w-[500px] flex-col text-center',
  notePrimary: 'text-sm font-semibold leading-5 text-foreground',
  noteSecondary: 'text-sm font-medium leading-5 text-foreground',
  primaryButton: 'w-full max-w-[500px]',
};
